export const FAQ_CATEGORIES = [
  { id: "all", label: "All questions" },
  { id: "basics", label: "The basics" },
  { id: "practice", label: "Practice & prayer" },
  { id: "belonging", label: "Belonging & conversion" },
  { id: "sources", label: "Sources & study" },
];

export const FAQS = [
  {
    id: 17,
    category: "basics",
    q: "Why would G-d give laws to everyone?",
    a: "Because G-d created the world with a purpose. He didn't make it and walk away; He made it intending something for it — a world that knows its Creator and lives in His light. The Seven Laws are part of that original design. They aren't rules added later to control people; they're the shape the world was meant to take from the very beginning, given to the first human being before any nation existed. And because the world is one divine ecosystem, nothing in it is separate: the way a man treats his wife shapes his children, who shape their friends, who shape a town. One honest shopkeeper changes a street; one cruel word travels further than anyone intended. The Sages said that a single person is 'an entire world', and that whoever saves one life saves a world — because everything is connected to everything else. That's why G-d's guidance reaches all the way down to the smallest choices in our private lives: what we say when no one is listening, what we take when no one would notice, how we speak to the people under our own roof. Those small choices aren't small. They're the underlying factor that everything else grows from. A world healed at the root — one person, one choice at a time — is the only kind of healed world there is. The Seven Laws are G-d's way of tending that root in every human heart, so that the world becomes what He made it to be.",
  },
  {
    id: 1,
    category: "basics",
    q: "What are the Seven Laws of Noah?",
    a: "They are the seven universal commandments that Jewish tradition teaches G-d gave to all humanity: prohibitions of idolatry, blasphemy, murder, theft, forbidden sexual relations and eating flesh from a living animal — and the positive obligation to establish courts of justice. Six were given to Adam; the seventh was added for Noah after the Flood (Talmud, Sanhedrin 56a–b; Rambam, Laws of Kings 9:1).",
  },
  {
    id: 2,
    category: "basics",
    q: "Who is a 'Noahide' or 'Ben Noach'?",
    a: "Literally 'a child of Noah' — in other words, every human being, since all of humanity descends from Noah. In practice the term is used for a non-Jew who consciously accepts and lives by the Seven Laws as G-d's instruction for the nations.",
  },
  {
    id: 3,
    category: "basics",
    q: "Is this a religion?",
    a: "It is better described as the Torah's universal code for humanity than as a separate religion with its own rituals and clergy. There are no mandated ceremonies, holidays or liturgy. What is asked is faith in the One G-d, ethical living according to the Seven Laws, and a sincere relationship with the Creator.",
  },
  {
    id: 4,
    category: "basics",
    q: "Are there really only seven laws?",
    a: "The seven are headings. Each contains many details — theft, for instance, includes withholding wages and kidnapping; courts of justice includes a whole framework of civil law. Beyond the strict obligations, the Torah also encourages gentiles to practise kindness, charity, honouring parents and gratitude to G-d.",
  },
  {
    id: 5,
    category: "belonging",
    q: "Do I need to convert to Judaism?",
    a: "No. The Torah does not ask gentiles to become Jews. The Rambam writes that a non-Jew who accepts and carefully observes the Seven Laws is counted among 'the pious of the nations of the world' and has a share in the World to Come (Laws of Kings 8:11). Conversion is a separate, optional path for those who feel called to join the Jewish people and take on all 613 commandments.",
  },
  {
    id: 6,
    category: "belonging",
    q: "Do Noahides have a place in the World to Come?",
    a: "Yes. The Talmud (Sanhedrin 105a) teaches that 'the righteous of all nations have a share in the World to Come', and the Rambam codifies this as law. Righteousness is measured by faithfulness to G-d and to the Seven Laws, not by being born into a particular people.",
  },
  {
    id: 7,
    category: "belonging",
    q: "Is there a formal way to 'become' a Noahide?",
    a: "There is no required ceremony. Some choose to make a formal declaration of acceptance before a rabbinical court (beit din), which many find meaningful and which the Rambam describes in the laws of the ger toshav. But the essential thing is inner acceptance: recognising G-d and committing to His laws for humanity.",
  },
  {
    id: 8,
    category: "belonging",
    q: "What about the religion I was raised in?",
    a: "The Noahide path requires belief in the One G-d of Israel without intermediaries, idols or additional deities, and this has real implications for prior beliefs. These are personal and sometimes tender questions. Most people find it valuable to study the sources and to speak honestly with a knowledgeable Orthodox rabbi who works with Noahides.",
  },
  {
    id: 9,
    category: "practice",
    q: "Can I pray? How?",
    a: "Absolutely. Prayer is open to every human being — Solomon prayed that G-d would hear 'the stranger who is not of Your people' (I Kings 8:41–43). There is no fixed Noahide liturgy, so you may pray in your own words and language. Many Noahides use the Psalms and set regular times each morning and evening to thank G-d, ask for their needs and praise Him.",
  },
  {
    id: 10,
    category: "practice",
    q: "Should I keep the Sabbath?",
    a: "The Sabbath as a day of complete rest from creative work is a sign of the covenant specifically between G-d and Israel (Exodus 31:16–17), and the Talmud (Sanhedrin 58b) indicates a gentile should not observe it in that full form. Noahides are, however, free to set aside a day for family, rest, study and gratitude to G-d. A rabbi familiar with Noahide practice can guide the details.",
  },
  {
    id: 11,
    category: "practice",
    q: "Do I need to eat kosher?",
    a: "No. The kosher laws were given to Israel. A Noahide may eat any species, but must not eat flesh taken from an animal while it was alive (Genesis 9:4). Many also refrain from blood, following the plain sense of that verse.",
  },
  {
    id: 12,
    category: "practice",
    q: "Can I keep other commandments — like charity, or honouring parents?",
    a: "Yes. The Rambam writes that a gentile who wishes to perform other commandments of the Torah in order to receive reward is not prevented from doing so, provided they are performed properly (Laws of Kings 10:10). Acts of kindness, charity, honouring parents and gratitude are especially praised. Some commandments that are signs of the Jewish covenant — such as tefillin or full Sabbath observance — are exceptions; ask a rabbi when unsure.",
  },
  {
    id: 13,
    category: "practice",
    q: "Is there a Noahide holiday or calendar?",
    a: "There are no mandated holidays. Some Noahide communities mark moments of gratitude on their own, and many enjoy learning about the Jewish festivals. The biblical calendar's rhythms — new moons, seasons of harvest — can be meaningful without becoming obligations.",
  },
  {
    id: 14,
    category: "sources",
    q: "Where do these laws appear in the Bible?",
    a: "They are derived from G-d's instruction to Adam in Genesis 2:16 and His covenant with Noah in Genesis 9:1–7, as expounded in the Talmud (Sanhedrin 56a–60a). The Rambam codifies them in Mishneh Torah, Laws of Kings and Their Wars, chapters 8–10 — the clearest classical summary.",
  },
  {
    id: 15,
    category: "sources",
    q: "Can a Noahide study Torah?",
    a: "The Talmud (Sanhedrin 59a) teaches that a gentile should study the parts of Torah relevant to the Seven Laws — and praises one who does, saying he is 'like a High Priest'. This includes the Written Torah, the ethical teachings of the Prophets and Writings, and the vast literature on the Noahide code. Advanced Talmudic study of laws specific to Israel is traditionally reserved for Jews.",
  },
  {
    id: 16,
    category: "sources",
    q: "How do I find a rabbi or community?",
    a: "Several organisations serve Noahides worldwide — AskNoah International, the Noahide Academy of Jerusalem and the Noahide World Center among them. Local Orthodox synagogues and Chabad centres are also frequently welcoming to sincere gentiles who wish to learn. See the Resources page.",
  },
];
